import { NgModule } from '@angular/core'
import { ScheduleComponent } from './schedule.component'
import { CommonModule } from '@angular/common'
import { LazyLoadModule } from 'lazy-load'
import { ScheduleDataService } from './schedule-data.service'
import { NoResultsModule } from '../libs/no-results/no-results.module'
import { EventListControlsModule } from '../libs/events/components/event-list-controls/event-list-controls.module'
import { MessageModule } from '../libs/message/message.module'
import { TableModule } from '../libs/table/table.module'
import { ElementIsVisibleModule } from '../libs/element-is-visible/element-is-visible.module'
import { ScheduleAnalyticsService } from './schedule-analytics.service'

@NgModule({
  imports: [
    CommonModule,
    LazyLoadModule,
    NoResultsModule,
    EventListControlsModule,
    TableModule,
    MessageModule,
    ElementIsVisibleModule
  ],
  exports: [ScheduleComponent],
  declarations: [ScheduleComponent],
  providers: [ScheduleDataService, ScheduleAnalyticsService]
})
export class ScheduleModule {}
